import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiLoadingSpinner, EuiSpacer, EuiText, EuiTextColor } from '@elastic/eui';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import ModalApp from '../../../components/Modal';
import { ItemInfoCPUser } from './item';
import { NuevoRepartoCP } from './nuevoRepartoComponent';

export const ModalConfiguracionRepartos = forwardRef((props,ref) =>{
   
    const {data, user, handleUpdate, refresh} = props
    const [isOpen,setIsOpen] = useState(false);
    const [dataSave, setDataSave] = useState(data) 
    const [idEmpleado, setIdEmpleado]=useState(undefined)

    useEffect(()=>{
        if(data && data.length>1)
        {
            const dataCustom = data.map((d)=>{
                return {...d, isDeleteable:true}
            })
            setDataSave([...dataCustom])
            setIdEmpleado(data[0].idEmpleado)
        }
    },[data, isOpen])

    useImperativeHandle(
        ref,
        () => ({
            onCloseModal() {
                setIsOpen(false)
            }
         })
      )

    const onChangeValueItem = (dataItem) =>{
        let pos = dataSave.findIndex((d) => d.idCP === dataItem.idCP);
        let newData = [ ...dataSave ];
        newData[pos] = {...dataItem};
        setDataSave(newData)
    }

    const onRepartoAdd = (nuevoReparto) =>{
        const newData = [...dataSave,nuevoReparto]
        setDataSave([...newData])
    }

    const onSave = useCallback(async() =>{
        
        const dataSaveRequest = dataSave.map(e => {
            return {idCP:e.idCP,porcentaje:e.porcentaje,tipo:'manual'}
        });
        
        const isOk = await handleUpdate(dataSaveRequest)
        if(isOk!==undefined && isOk===true){
            setIsOpen(false)
            refresh()
        }
    },[idEmpleado,dataSave])

    const onRepartoRemove = (idCP) =>{
        const newData = dataSave.filter((f=> f.idCP!==idCP));
        setDataSave([...newData])
    }

    const total = useMemo(()=>{ 
        const allData = [...dataSave]
        return allData.length>0 ? allData.map((item, i) => (item.porcentaje)).reduce((total, porcentaje) =>{return total + porcentaje;}) : 0
    },[dataSave, data])

    const isInvalidPorcentaje = useMemo(()=> total>100,[total])

    const totalMsg = useMemo(()=> {
        const color = total>100 ? "#BD271E" : "#008b8b";
        return <EuiFlexItem grow={false}><EuiText><strong><EuiTextColor style={{color:`${color}`}}>{`Total Porcentaje: ${total}%`}</EuiTextColor></strong></EuiText></EuiFlexItem> 
    },[total])

    const generateStruct = useMemo(()=>{
        return dataSave && dataSave.map((d, i)=> {
            return(<>
                <EuiFlexItem>
                    <EuiFlexGroup className='item-list-cpUser'>
                        <ItemInfoCPUser data={d} error={isInvalidPorcentaje} onChange={onChangeValueItem} handleDelete={onRepartoRemove}/>
                    </EuiFlexGroup>
                </EuiFlexItem>
            </>)
        })
    },[dataSave,isInvalidPorcentaje,onChangeValueItem,onRepartoRemove])

    const errorMsg = useMemo(()=> {
        return total>100 ?
        <EuiFlexItem><EuiText color={'danger'}>{`Exceso en el total de porcentajes.`}</EuiText></EuiFlexItem> 
        :<EuiFlexItem/>
    },[total])

    const titleUser = useMemo(()=> <EuiFlexItem style={{alignItems:'center'}}><EuiText><h4>{user!==undefined?`Repartos CPs de ${user}`:'Repartos CPs'}</h4></EuiText></EuiFlexItem>,[user])

    const btnSave = useMemo(()=> {
        if(dataSave.length>1){
            return(<EuiFlexItem grow={false}>
                <EuiButton fullWidth size='s' fill onClick={()=>onSave()}>{`Guardar`}</EuiButton>
            </EuiFlexItem>)
        }else{return null}
    },[dataSave,total,onSave])

    const btnCancel = useMemo(()=> {
        return(<EuiFlexItem grow={false}>
            <EuiButton fullWidth size='s' fill color='danger' onClick={()=>setIsOpen(false)}>{`Cancelar`}</EuiButton>
        </EuiFlexItem>)
    },[])

    const containerActionsFooter = useMemo(() =>{
        return(<EuiFlexGroup>
            {btnCancel}
            {isInvalidPorcentaje ? errorMsg : btnSave}
        </EuiFlexGroup>)
    },[isInvalidPorcentaje,btnSave, errorMsg])

    const containerModal = () =>{
        return (
            <>
            <EuiFlexGroup className='title-cpUser-popover'>
                {titleUser}
            </EuiFlexGroup>
            <EuiSpacer size='l'/>
            <EuiFlexGroup direction='column' className='content-cpUser-popover'>
                <EuiFlexItem>
                    <EuiFlexGroup style={{border: '1px solid #d3dae6'}}>
                        <EuiFlexItem><NuevoRepartoCP onRepartoAdd={onRepartoAdd}/></EuiFlexItem>
                    </EuiFlexGroup>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiFlexGroup direction='column' style={{maxHeight:'400px',overflowY:'auto'}}>
                        {data!==undefined ? generateStruct : <EuiLoadingSpinner size='l'/>}
                    </EuiFlexGroup>
                    </EuiFlexItem>
            </EuiFlexGroup>
        </>
        )
    }

    const footerModal = () =>{
        return(
            <EuiFlexGroup className={`bottom-panel-cpUser-popover${isInvalidPorcentaje?'-error':''}`} alignItems='center' justifyContent='spaceAround'>
               <EuiFlexItem>{containerActionsFooter}</EuiFlexItem> 
                {totalMsg}
            </EuiFlexGroup>
        )
    }

    return(
        <>
            <EuiButton fullWidth size='s' fill onClick={()=>setIsOpen(true)}>{`Configurar`}</EuiButton>
            <ModalApp title={'Configuración De Repartos Costes CPs'} content={containerModal()} contentFooter={footerModal()} onClose={()=>{setIsOpen(false)}} isOpen={isOpen}/>
        </>
    )
});